// extracted by css-extract-rspack-plugin
export default {"root":"BQ2sFb","draggable":"TwKhwR","selected":"TMgmmp","dragging":"URHmIf"};